/** Recipient — funnel CTA 라벨·mailto 공통 사용 */
export const TINDLO_HELLO_EMAIL = 'hello@tindlo.com';

const DEMO_MAIL_TO = TINDLO_HELLO_EMAIL;

// mailto 동작에는 localhost/host와 무관. 기본 메일 앱 미설정이면 무응답처럼 보일 수 있음.

const DEMO_MAIL_SUBJECT = 'Tindlo inquiry';

function safeMailtoEncode(value: string): string {
  return encodeURIComponent(value).replace(/'/g, '%27');
}

/**
 * 짧은 mailto(URL 길이·클라 제한 회피) — 라벨에 이메일을 노출해 복사로도 가능
 */
export function buildTindloDemoMailtoHref(): string {
  const subject = safeMailtoEncode(DEMO_MAIL_SUBJECT);
  return `mailto:${DEMO_MAIL_TO}?subject=${subject}`;
}
